import React from 'react';

interface MainContentsProps {
  children: React.ReactNode;
}

export const MainContents: React.FC<MainContentsProps> = ({ children }) => {
  return <div className="px-lg py-sm">{children}</div>;
};
